export default {
  methods: {
    crearSolicitud () {
      var solicitudApi = {
        tokenId: encodeURIComponent(localStorage.getItem('ventasTokenId')),
        local: localStorage.getItem('ventasLocal')
      }
      return solicitudApi
    },
    formatoFecha (fecha) {
      if (!fecha) return null
      const [year, month, day] = fecha.split('-')
      return `${day}/${month}/${year}`
    },
    parseDate (fecha) {
      if (!fecha) return null
      const [day, month, year] = fecha.split('/')
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins.js